import React from 'react';
import classNames from 'classnames';

import styles from './follow-button.scss';
import { Button } from '../button';
import { FollowingIcon } from './following-icon';

interface Props {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className: string;
  dataHook: string;
  isFollowing: boolean;
  unfollowText: string;
  followText: string;
  primaryButtonClass: string;
  secondaryButtonClass: string;
  type: 'text' | 'icon' | 'animated';
}

export const FollowButton: React.StatelessComponent<Props> = ({
  isFollowing,
  followText,
  unfollowText,
  primaryButtonClass,
  secondaryButtonClass,
  dataHook,
  onClick,
  className,
  type,
}) => {
  const isTextButton = (type === 'animated' && !isFollowing) || type === 'text';

  const ffButtonClassNames = classNames(styles.button, className, 'ma-all-members-buttons-corner-radius', {
    [styles.textButton]: isTextButton,
    [styles.iconButton]: !isTextButton,
    [primaryButtonClass]: !isFollowing,
    [secondaryButtonClass]: isFollowing,
  });

  return (
    <Button onClick={onClick} className={ffButtonClassNames} dataHook={dataHook}>
      <div className={classNames(styles.text, type === 'animated' ? styles.animated : '')}>
        <div className={styles.verticalAlign}>{isFollowing ? unfollowText : followText}</div>
      </div>
      <FollowingIcon className={styles.icon} />
    </Button>
  );
};
